import { useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";

export function useFeedItemOptionsDropdown() {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isLoading, refetch } = useQuery(
    ["diamonds"],
    async () => {
      // console.log("Fetching from API...");

      const res = await makeAuthedRequest(`diamonds`, {
        method: "GET",
      });

      if (res.ok) {
        const json = await res.json();
        //console.log("API Response:", json);
        return json;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    },
    {
      staleTime: 5 * 60 * 1000,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}

export function useFeedItemOptionsDropdownGroup() {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isLoading, refetch } = useQuery(
    ["groups"],
    async () => {
      // console.log("Fetching from API...");

      const res = await makeAuthedRequest(`groups`, {
        method: "GET",
      });

      if (res.ok) {
        const json = await res.json();
        //console.log("API Response:", json);
        return json;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    },
    {
      staleTime: 5 * 60 * 1000,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}
